import { render } from "./TheFeedback.vue?vue&type=template&id=e0d1d48e&ts=true"
import script from "./TheFeedback.vue?vue&type=script&lang=ts"
export * from "./TheFeedback.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__